export default __webpack_public_path__ + "static/media/marker-icon-blueNavy.692a6e07.svg";